import { GetStatementsApiParameter } from "@gerrieDev/Services/StatementService";
import loadStatementData from "@gerrieDev/Store/Data/Statements/Handlers/LoadStatements";
import { getStatementDataView, StatementDataViewContext } from "@gerrieDev/Store/Data/Statements/StatementSelector";
import updateSearchFields from "@gerrieDev/Store/Pages/Statements/Handlers/UpdateSearchFields";
import { CustomState } from "@gerrieDev/Store/Reducers";
import { getCookie } from "@insite/client-framework/Common/Cookies";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { ExcludeFromNavigation } from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import qs from "qs";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    settings: getSettingsCollection(state),
    getStatementsParameter: state.customPagesReducer.statements.getStatementsParameter,
    statementsDataView: getStatementDataView(state, state.customPagesReducer.statements.getStatementsParameter),
    location: getLocation(state),
});

const mapDispatchToProps = {
    loadStatementData,
    updateSearchFields,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

class StatementsPage extends React.Component<Props> {
    UNSAFE_componentWillMount(): void {
        const pageSizeCookie = getCookie("Statements-PageSize");
        const pageSize = pageSizeCookie ? parseInt(pageSizeCookie, 10) : undefined;
        if (this.props.location.search) {
            const getStatementsApiParameter = parseQueryString<GetStatementsApiParameter>(this.props.location.search);
            if (pageSize) {
                getStatementsApiParameter.pageSize = pageSize;
            }
            this.props.updateSearchFields({ ...getStatementsApiParameter, type: "Replace" });
        }

        if (!this.props.statementsDataView.value && !this.props.statementsDataView.isLoading) {
            this.props.loadStatementData(this.props.getStatementsParameter);
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.getStatementsParameter !== this.props.getStatementsParameter) {
            const queryString = qs.stringify(this.props.getStatementsParameter);
            this.props.history.replace(`${this.props.location.pathname}${queryString !== "" ? `?${queryString}` : ""}`);
        }

        // if this is undefined it means someone changed the filters and we haven't loaded the new collection yet
        if (!this.props.statementsDataView.value && !this.props.statementsDataView.isLoading) {
            this.props.loadStatementData(this.props.getStatementsParameter);
        }
    }

    render() {
        return (
            <Page>
                <StatementDataViewContext.Provider value={this.props.statementsDataView}>
                    <Zone contentId={this.props.id} zoneName="Content" />
                </StatementDataViewContext.Provider>
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: withHistory(connect(mapStateToProps, mapDispatchToProps)(StatementsPage)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
        fieldDefinitions: [
            ExcludeFromNavigation,
        ],
    },
};

export default pageModule;

export const StatementsPageContext = "StatementsPage";